import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;
const headers = () => ({ token: localStorage.getItem("token") });

function Notifications() {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/notifications`, { headers: headers() });
      setNotifications(response.data.notifications || []);
      setUnreadCount(response.data.unreadCount || 0);
      setError("");
      window.dispatchEvent(new CustomEvent("notifications-updated", { detail: { unreadCount: response.data.unreadCount || 0 } }));
    } catch (requestError) {
      setError(requestError.response?.data?.message || "Kunde inte hämta notiser");
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function openNotification(notification) {
    if (!notification.readAt) {
      await axios.patch(`${API_URL}/notifications/${notification._id}/read`, {}, { headers: headers() });
    }
    if (notification.link) navigate(notification.link);
    else load();
  }

  async function markAllRead() {
    await axios.patch(`${API_URL}/notifications/read-all`, {}, { headers: headers() });
    await load();
  }

  return <div className="mx-auto w-full max-w-4xl px-4 py-4"><div className="theme-card">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-700">Notifieringar</p>
        <h1 className="mt-2 text-lg font-bold text-slate-800">Dina notiser</h1>
        <p className="mt-1 text-sm text-slate-600">{unreadCount} olästa</p>
      </div>
      {unreadCount > 0 && <button className="theme-button-secondary px-4 py-2 text-sm" onClick={markAllRead}>Markera alla som lästa</button>}
    </div>
    {error && <div className="theme-alert-error mt-4">{error}</div>}
    <div className="mt-5 space-y-3">
      {!notifications.length && <div className="theme-empty-state">Du har inga notiser.</div>}
      {notifications.map((notification) => <button key={notification._id} onClick={() => openNotification(notification)} className={`theme-panel w-full text-left ${notification.readAt ? "opacity-70" : "border-sky-400"}`}>
        <div className="flex items-center justify-between gap-3">
          <span className="font-semibold text-slate-800">{notification.title}</span>
          {!notification.readAt && <span className="h-2.5 w-2.5 rounded-full bg-sky-500" aria-label="Oläst" />}
        </div>
        <p className="mt-2 text-sm text-slate-600">{notification.message}</p>
        <p className="mt-2 text-xs text-slate-500">{new Date(notification.createdAt).toLocaleString("sv-SE")}</p>
      </button>)}
    </div>
  </div></div>;
}

export default Notifications;
